import { FormErrors } from 'redux-form';
import { isValidPhoneValidationCode } from '../../../../logic/phone-validation-code/phone-validation-code.validator';
import { clearEmptyFields } from '../../../../logic/validators/utils';
import { isRequiredValidator } from '../../../../logic/validators/validators';

export const VERIFY_PHONE_FORM_NAME = 'verify-phone';

export interface VerifyPhoneFormValues {
  verificationCode?: string;
}

export type VerifyPhoneFormValidationErrors = FormErrors<VerifyPhoneFormValues, any>;

export const validateVerifyPhoneForm = (formValues: VerifyPhoneFormValues) => {
  const { verificationCode } = formValues;

  const errors: VerifyPhoneFormValidationErrors = {
    verificationCode:
      isRequiredValidator(verificationCode) || isValidPhoneValidationCode(verificationCode),
  };

  return clearEmptyFields(errors);
};
